import React from 'react';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';

import { useSOHeaderDetailLang } from './hooks';

import makeClasses from './SOHeaderDetail.style';

interface Props {
  productsCount: number;
}

export function SOHeaderDetail({ productsCount }: Props) {
  const classes = makeClasses();
  const lang = useSOHeaderDetailLang(productsCount);

  return (
    <div className={classes.root}>
      <div className={classes.titleRow}>
        <h2 className={classes.title}>{lang.title}</h2>
        <span className={classes.scheduledTag}>
          <DateRangeOutlinedIcon className={classes.scheduledTagIcon} />
          <span className={classes.scheduledTagText}>{lang.scheduledTag}</span>
        </span>
      </div>
      <p className={classes.productsCount}>{lang.productsCount}</p>
    </div>
  );
}
